//import 'ol/ol.css';
import { FeatureType, ICAMSKey } from '../Models/UtilityModels';
import * as toastr from "toastr";
import * as events from '../Bus/Bus';
import { Utilities, ModalAction } from '../Utility/Utilities';

export class Photos {

    // ----------------------------------------------------------- //
    // GLOBAL VARS

    // ----------------------------------------------------------- //
    private filesToUpload: File[];
    private maxFileSize: number = 1048576;
    private allowedFileTypes = [".pdf", ".jpg", ".jpeg", ".gif", ".png", ".webp", ".doc", ".docx", ".xls", ".xlsx"];

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        this.filesToUpload = [];
    }

    // ----------------------------------------------------------- //
    // Show photo modal 
    public showPhotoModal = (url: string): void => {
        const self = this;
        Utilities.BlockUI();
        $('#placeholder-for-photoModals').load(window.G_SITEFOLDERNAME +'/Photos/ShowPhotoNoModal', { photoURL: url }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            Utilities.GetModal('#showPhotoModal', ModalAction.Create);
        });
    }

    // ----------------------------------------------------------- //
    // Public functions
    public createPhotoThumbnail = (containingElement: HTMLElement, errorCallback: Function): void => {
        const key: ICAMSKey = $(containingElement).data("photo");

        // Check to see if there is a valid key
        var type: string = this.getXGKeyFromFeatureType(key.featureType);
        if (type === '' || !key.code) {
            return;
        }

        // Create the URLs
        var code: string = encodeURIComponent(key.code.toString());
        var thumbURL = '/CAMSLibraryLink/FetchFirstResourceByXgKey/' + type + '/' + code+"?thumb=true";
        var largerURL = '/CAMSLibraryLink/FetchFirstResourceByXgKey/' + type + '/' + code;

        // Add a div container
        var $link = $('<div>', { 'title': 'click to open full size image in a new tab', 'style': 'position: relative;' });
        $link.on('click', function () { events.bus.publish(events.eventPhotoShowModal(largerURL)); });
        $(containingElement).append($link);

        // Add the img element
        var style = "border: 1px solid grey; border-radius: 2px; max-width: 100%; height: auto; border: 1px solid grey; border-radius: 2px; cursor: pointer;"
        var $thumb = $('<img>', { 'id': 'thumb_' + code, 'src': thumbURL, 'class': 'image-thumbnail', 'style': style });

        // IF there is no img, hide the element. This will show the 'No Photo' text underneath
        $thumb.on('error', function (r) {
            if (errorCallback != null) errorCallback(true);
        }); 

        // Append new element to the DOM
        $($link).append($thumb);

        return;
    }

    // ----------------------------------------------------------- //
    // File uploads
    public handleFiles = (fileInput: HTMLInputElement, listTarget: Element): void => {
        let self = this;
        
        let files: Array<File> = [];
        let maxSizeFlag = false;
        var fileResizePromises: Array<Promise<File>> = [];
        if (fileInput.files != null) {
            for (let i = 0; i < fileInput.files.length; i++) {
                if (fileInput.files[i].size > self.maxFileSize && self.isFileImage(fileInput.files[i]) == true) {
                    maxSizeFlag = true;
                    fileResizePromises.push(self.resizeImage(fileInput.files[i], self.maxFileSize));
                }
                else {
                    files.push(fileInput.files[i]);
                }
            }
        }

        if (maxSizeFlag == true) {
            Promise.all(fileResizePromises)
                .then(function (newFiles) {
                    newFiles.forEach(f => files.push(f));
                    toastr.info("Some files have been resized as they exceeded the max file size limit.");
                    completeProcess();
                });
        }
        else {
            completeProcess();
        }

        function completeProcess() {
            //remove change handler
            $(fileInput).off('change');

            //merge newly chosen files with existing array
            $.merge(self.filesToUpload, files);

            // Check if this is an allowed file-type
            var tmpFileList = [];
            self.filesToUpload.forEach((f,i) => {
                var allowedType = null;
                self.allowedFileTypes.forEach(t => { if (f.name.toLowerCase().indexOf(t.toLowerCase()) > 0) allowedType = true; });
                if (allowedType == true) {
                    tmpFileList.push(f);
                }
            });
            self.filesToUpload = tmpFileList;
            
            //de-duplicate
            let tempObject = new ClipboardEvent("").clipboardData || new DataTransfer()
            for (var i = self.filesToUpload.length - 1; i > -1; i--) {
                for (var j = i - 1; j > -1; j--) {
                    if (self.filesToUpload[i].name === self.filesToUpload[j].name)
                        self.filesToUpload.splice(j, 1);
                }
                tempObject.items.add(self.filesToUpload[i]);
            }

            //update fileinput files
            fileInput.files = tempObject.files;

            //restore change handler
            $(fileInput).on('change', function (e: Event) { self.handleFiles((<HTMLInputElement>e.target), listTarget); });

            self.buildListMarkup(self.filesToUpload, fileInput, listTarget);
        }
    }

    public setupUploader = (modalId: string): void => {
        let self = this;
        self.filesToUpload = [];

        //get form elements from the active modal
        let $fileUploader = $(modalId).find('[name="Files"]').first();
        let $chooseButton = $(modalId).find('[name="FileUpload_ChooseFilesBtn"]').first();
        let $listTarget = $(modalId).find('[name="FileUpload_FileList"]').first();

        //handler for file input
        $fileUploader.on('change', function (e: Event) { self.handleFiles((<HTMLInputElement>e.target), $listTarget[0]); });

        //handler for browse button
        $chooseButton.on('click', function (e) {
            if ($fileUploader) {
                $fileUploader.click();
            }
        });
    }

    // ----------------------------------------------------------- //
    // Private functions
    private getXGKeyFromFeatureType = (featureType: FeatureType): string => {
        switch (featureType) {
            case FeatureType.Maint: {
                return 'Maint';
            }
            case FeatureType.Infra: {
                return 'Infra';
            }
            case FeatureType.Land: {
                return 'Land';
            }
            case FeatureType.Route: {
                return 'Route';
            }
            case FeatureType.TRO: {
                return 'TRO';
            }
            default:
                //unsupported
                return '';
        }
    }

    private removeFileToUpload = (index: number, fileInput: HTMLInputElement, listTarget: Element): void => {
        let self = this;

        //remove change handler
        $(fileInput).off('change');

        this.filesToUpload.splice(index, 1);
        let tempObject = new ClipboardEvent("").clipboardData || new DataTransfer()
        for (var i = 0, l1 = this.filesToUpload.length; i < l1; i++) {
            tempObject.items.add(this.filesToUpload[i]);
        }

        //update fileinput files
        fileInput.files = tempObject.files;

        //restore change handler
        $(fileInput).on('change', function (e: Event) { self.handleFiles((<HTMLInputElement>e.target), listTarget); });

        self.buildListMarkup(this.filesToUpload, fileInput, listTarget);
    }

    private buildListMarkup = (files: File[], fileInput: HTMLInputElement, listTarget: Element): void => {
        let self = this;
     
        //loop over files and build markup for the list
        if (files.length == 0) {
            listTarget.innerHTML = "<p>No files selected!</p>";
        } else {
            listTarget.innerHTML = "";
            const list = document.createElement("ul");
            listTarget.appendChild(list);
            for (let i = 0; i < files.length; i++) {
                //create a list element
                const li = document.createElement("li");
                list.appendChild(li);

                //create the image thumbnail
                if (self.isFileImage(files[i])) {
                    const img = document.createElement("img");
                    img.src = URL.createObjectURL(files[i]);
                    img.height = 60;
                    img.onload = function () {
                        URL.revokeObjectURL(img.src);
                    }
                    li.appendChild(img);
                }

                //create the metadata text
                const info = document.createElement("span");
                if (files[i].size < 1024)//less than 1KB, show as bytes
                {
                    info.innerHTML = files[i].name + " ( " + files[i].size + " bytes )";
                }
                else if (files[i].size < 1048576)//less than 1MB, show as KB
                {
                    info.innerHTML = files[i].name + " ( " + (files[i].size / 1024).toFixed(1) + " KB )";
                }
                else {//anything bigger show as MB
                    info.innerHTML = files[i].name + " ( " + (files[i].size / 1048576).toFixed(1) + " MB )";
                }
                li.appendChild(info);

                //create the remove icon
                const remover = document.createElement("a");
                remover.innerHTML = '<i class="fas fa-trash pl-2"></i>';
                remover.setAttribute('title', 'click to remove file');
                remover.onclick = function () { self.removeFileToUpload(i, fileInput, listTarget); };
                li.appendChild(remover);
            }
        }
    }

    private resizeImage = (file: File, maxFileSize: number): Promise<File> => {
        var scaleFactor = 2;
        if (file.size > maxFileSize) {
            scaleFactor = Math.ceil(file.size / maxFileSize / 2);
        }
        
        return new Promise<File>((resolve) => {
            const reader = new FileReader();
            reader.onload = (e: any) => {
                const image = new Image();
                image.src = e.target.result;

                image.onload = rs => {
                    var f2 = file;
                    const imgHeight = rs.currentTarget['height'];
                    const imgWidth = rs.currentTarget['width'];

                    const elem = document.createElement('canvas');
                    elem.width = imgWidth / scaleFactor;
                    elem.height = imgHeight / scaleFactor;
                    const ctx = elem.getContext('2d');
                    ctx.drawImage(image, 0, 0, imgWidth, imgHeight, 0, 0, elem.width, elem.height);
                    
                    ctx.canvas.toBlob((blob) => {
                        const file = new File([blob], f2.name, {
                            type: f2.type,
                            lastModified: Date.now()
                        });
                        resolve(file)
                    }, f2.type, 0.8); // Set the quality to image/webp standards
                      
                };
            };

            reader.readAsDataURL(file);

        });
    }

    private isFileImage = (file: File): Boolean => {
        if (file.name.toLowerCase().includes(".png")
            || file.name.toLowerCase().includes(".jpg")
            || file.name.toLowerCase().includes(".jpeg")
            || file.name.toLowerCase().includes(".gif"))
            return true;
        else return false;
    }
}